import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'text-area-specs',
  templateUrl: './text-area-specs.component.html',
  styleUrls: ['./text-area-specs.component.sass']
})
export class TextAreaSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/textarea/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
